import { render, staticRenderFns } from "./ManageSkills.vue?vue&type=template&id=8893996a&"
import script from "./ManageSkills.vue?vue&type=script&lang=js&"
export * from "./ManageSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports